/**
 * Animal Enums (retained from ERP for shared animal event/movement functionality)
 * CalfHealth: pig-specific enums removed; only generic animal constants remain.
 */

export const GENERAL_EVENT_DIAGNOSE_VALUES = [
  "scours",
  "brd",
  "pneumonia",
  "navel_infection",
  "joint_ill",
  "bloat",
  "ringworm",
  "coccidiosis",
  "cryptosporidiosis",
  "dehydration",
  "lameness",
  "fever",
  "injury",
  "other",
];

export function normalizeGeneralEventDiagnose(value) {
  if (!value) return "";
  const normalized = String(value).trim().toLowerCase().replace(/\s+/g, "_");
  return GENERAL_EVENT_DIAGNOSE_VALUES.includes(normalized) ? normalized : value;
}

export const PRODUCTION_STAGES = {
  BIRTH_ARRIVAL: "birth-arrival",
  COLOSTRUM: "colostrum",
  MILK_PHASE: "milk-phase",
  TRANSITION: "transition",
  WEANING: "weaning",
  REARING: "rearing",
  FATTENING: "fattening",
  BREEDING: "breeding",
  ACTIVE: "active",
  ARCHIVE: "archive",
};

export const PRODUCTION_STAGE_VALUES = [
  "birth-arrival",
  "colostrum",
  "milk-phase",
  "transition",
  "weaning",
  "rearing",
  "fattening",
  "breeding",
  "active",
  "archive",
];

export function normalizeProductionStage(value) {
  if (!value) return "";
  const normalized = String(value).trim().toLowerCase().replace(/\s+/g, "-");
  return PRODUCTION_STAGE_VALUES.includes(normalized) ? normalized : value;
}
